// componentes/A11yToolbar.tsx
import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import AccessibilityIcon from "@mui/icons-material/Accessibility";

export const A11yToolbar: React.FC = () => (
  <Box
    component="nav"
    role="navigation"
    aria-label="Barra de Acessibilidade"
    sx={{
      position: "fixed",
      top: "10px",
      left: "10px",
      zIndex: 1100,
    }}
  >
    <Tooltip title="Acessibilidade" arrow>
      <IconButton
        aria-label="Acessibilidade"
        sx={{
          backgroundColor: "#e0e0e0",
          color: "#000",
        }}
      >
        <AccessibilityIcon />
      </IconButton>
    </Tooltip>
  </Box>
);
